import { render } from "./AirtelDepositWebsite.vue?vue&type=template&id=55af759c&scoped=true"
import script from "./AirtelDepositWebsite.vue?vue&type=script&lang=js"
export * from "./AirtelDepositWebsite.vue?vue&type=script&lang=js"

import "./AirtelDepositWebsite.vue?vue&type=style&index=0&id=55af759c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55af759c"]])

export default __exports__